<div class="ui-modal"
>
  @if (isReviewStarted) {
    <div class="header flex-row end-center">
      <span class="ui-icon-close c-p" mat-dialog-close></span>
    </div>
  }
  @if (isCustomReviewStarted) {
    <div class="header flex-row space-between-center">
      @if (isCustomReviewStarted) {
        {{ 'G2_FEEDBACK_MODAL.TITLE'|translate }}
      }
      <span class="ui-icon-close c-p" mat-dialog-close></span>
    </div>
  }
  <div class="body">
    <div class="flex-col gap-10">
      @if (isReviewStarted) {
        @if (data.url) {
          <iframe
            [src]="sanitizer.bypassSecurityTrustResourceUrl(data.url)"
            width="100%"
            height="600"
            frameborder="0"
            style="border: none;"
          ></iframe>
        }
      } @else {
        @if (!isCustomReviewStarted) {
          <div style="text-align: center">
            <img src="assets/icons/logo.svg" width="80px">
            <div class="g2-title">
              {{ 'G2_FEEDBACK_MODAL.TITLE'|translate }}
            </div>
          </div>
          <div class="flex-row gap-8 center-center">
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <span class="ui-icon-star c-p" (mouseenter)="hoverRating = i" (mouseleave)="hoverRating=0"
                    [class.ui-icon-star-fill]="i<= hoverRating || i<= selectedRating"
                    (click)="selectedRating = i"
              ></span>
            }
          </div>


          <div>
            {{ 'G2_FEEDBACK_MODAL.DESCRIPTION'|translate }}
            <a class="link" href="https://legal.g2.com/privacy-policy" target="_blank"
               rel="noopener"
            >{{ 'G2_FEEDBACK_MODAL.PRIVACY_POLICY'|translate }}</a>
            {{ 'G2_FEEDBACK_MODAL.AND'|translate }}
            <a class="link" href="https://legal.g2.com/terms-of-use" target="_blank"
               rel="noopener"
            >{{ 'G2_FEEDBACK_MODAL.TERMS'|translate }}</a>.
          </div>
          <div style="text-align: center"> {{ 'G2_FEEDBACK_MODAL.APPROX_TIME'|translate }}</div>
          <div class="flex-row space-between-center">
            <ui-button
              (clickAction)="remindLater()"
              [text]="'G2_FEEDBACK_MODAL.BUTTONS.REMIND_LATER'|translate"
              type="default"
            ></ui-button>

            <ui-button
              (clickAction)="start()"
              [disabled]="!selectedRating"
              [text]="'G2_FEEDBACK_MODAL.BUTTONS.START'|translate"
              type="primary"
            ></ui-button>

          </div>

          <button type="button" class="g2x-tertiary" (click)="dontAskAgain()">
            Don’t show me this again
          </button>
        } @else {
          <div class="flex-col gap-8">
            <div>
              @if (selectedRating < 4) {
                {{ 'G2_FEEDBACK_MODAL.CUSTOM_DESCRIPTION_BAD'|translate }}
              } @else {
                {{ 'G2_FEEDBACK_MODAL.CUSTOM_DESCRIPTION_GOOD'|translate }}
              }

            </div>
            <textarea [formControl]="feedbackMessageControl">

            </textarea>
            <div class="flex-row end-center gap-8">
              <ui-button
                (clickAction)="closeCustomReview()"
                [text]="'G2_FEEDBACK_MODAL.BUTTONS.BACK'|translate"
                type="default"
              ></ui-button>
              <ui-button
                [disabled]="feedbackMessageControl.invalid"
                (clickAction)="createFeedback()"
                [text]="'G2_FEEDBACK_MODAL.BUTTONS.SEND'|translate"
                type="primary"
              ></ui-button>
            </div>
          </div>

        }

      }


    </div>


  </div>
</div>

